var map = {
	"./de/entries_titles_kid": [
		"mwOV",
		46
	],
	"./en/entries_titles_kid": [
		"kySE",
		30
	],
	"./fr/entries_titles_kid": [
		"+TZm",
		14
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Vc92";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/entries_titles_kid$
// module id = Vc92
// module chunks = 70